import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import '../../../css/huerto/modalsFichaCliente.css';
import FunctionGeneral from '../functionsGeneral';

function compareDateEqualsIPOProyeccion(dateIPO, DateProyeccion) {
    try {
        DateProyeccion = new FunctionGeneral()
            .formatFecha(DateProyeccion.split('T')[0].split('-'))
            .split('/');
        dateIPO = dateIPO.split('/');
    } catch {
        return false;
    }
    if (dateIPO.length !== 3 || DateProyeccion.length !== 3) return false;
    if (DateProyeccion[1] === dateIPO[1] && DateProyeccion[2] === dateIPO[2])
        return true;
    return false;
}
function compareDateEqualsHoyProyeccion(DateProyeccion, DateProyeccionNext) {
    var _fechaActual = new Date();
    try {
        DateProyeccion = new FunctionGeneral()
            .formatFecha(DateProyeccion.split('T')[0].split('-'))
            .split('/');
        DateProyeccionNext = new FunctionGeneral()
            .formatFecha(
                DateProyeccionNext.ReferenceDate.split('T')[0].split('-')
            )
            .split('/');
    } catch {
        if (DateProyeccionNext === undefined) {
            if (
                parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
                parseInt(DateProyeccion[1]) === _fechaActual.getMonth() + 1 &&
                parseInt(DateProyeccion[0]) <= _fechaActual.getDate()
            )
                return true;
        }
        return false;
    }

    if (DateProyeccion.length !== 3) return false;
    if (
        parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
        parseInt(DateProyeccion[1]) === _fechaActual.getMonth() &&
        !(parseInt(DateProyeccionNext[0]) <= _fechaActual.getDate())
    )
        return true;
    else if (
        parseInt(DateProyeccion[2]) === _fechaActual.getFullYear() &&
        parseInt(DateProyeccion[1]) === _fechaActual.getMonth() + 1 &&
        parseInt(DateProyeccion[0]) <= _fechaActual.getDate()
    )
        return true;

    return false;
}

function ModalFichaClienteProyeccion(props) {
    const [scrollTable, setscrollTable] = useState(false);

    return (
        <div className="c-modal" aria-hidden={'false'}>
            <div className="c-modal__overlay js-modal-close"></div>
            <div
                className="c-modal__wrapper modalFichaCliente"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header className="c-modal__header">
                    <div className="o-layout__item u-11/12 ">
                        <div>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20.035 20.04"
                                style={{ position: 'relative', top: '2px' }}
                            >
                                <path
                                    d="M18.333,16.667v-12h-4v12H13v-8H9v8H7.667v-4h-4v4H2.333V2H1V18H19.667V16.667Zm-12,0H5V14H6.333Zm5.333,0H10.333V10h1.333Zm5.333,0H15.667V6H17Z"
                                    transform="translate(-1 -2)"
                                    fill={'#004666'}
                                />
                            </svg>
                            <label className="u-h3 u-ml-xsmall">
                                Proyección
                            </label>
                        </div>
                    </div>

                    <div className="o-layout__item u-1/12">
                        <button
                            onClick={() => props.setModalProyeccion(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Close this dialog window."
                        />
                    </div>
                </header>

                <div className="c-modal__content">
                    {
                        <div
                            className="tablaModalProyeccion"
                            style={{
                                overflowY: scrollTable ? 'hidden' : 'auto',
                            }}
                        >
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            style={{
                                                minWidth: '25px',
                                                maxWidth: '25px',
                                            }}
                                        ></TableCell>
                                        <TableCell
                                            style={{
                                                minWidth: '110px',
                                                maxWidth: '110px',
                                            }}
                                            className="u-text-muted"
                                        >
                                            Cuota
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                minWidth: '100px',
                                                maxWidth: '100px',
                                            }}
                                            className="u-text-muted"
                                        >
                                            Fecha
                                        </TableCell>
                                        {props.opt_CPC_NEXT && (
                                            <TableCell
                                                style={{
                                                    minWidth: '120px',
                                                    maxWidth: '120px',
                                                }}
                                                className="u-text-muted"
                                            >
                                                Valor de Compra
                                            </TableCell>
                                        )}
                                        {props.opt_CPC_NEXT && (
                                            <TableCell
                                                style={{
                                                    minWidth: '70px',
                                                    maxWidth: '70px',
                                                }}
                                                className="u-text-muted"
                                            >
                                                Puntos
                                            </TableCell>
                                        )}
                                        <TableCell
                                            style={{
                                                width: '25px',
                                                maxWidth: '25px',
                                            }}
                                        >
                                            <div
                                                className="c-icon c-icon--[semantic-user]"
                                                style={{
                                                    fontSize: '20px',
                                                    fontWeight: 'bold',
                                                    marginRight: '7px',
                                                }}
                                            ></div>
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                width: '25px',
                                                maxWidth: '25px',
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="19.006"
                                                height="15"
                                                viewBox="0 0 19.006 15"
                                            >
                                                <path
                                                    d="M17.578,4.083h-2.1l-.585-1.517A3.921,3.921,0,0,0,11.232,0H6.767A3.923,3.923,0,0,0,3.112,2.567L2.527,4.083H.422a.434.434,0,0,0-.409.544L.224,5.5a.425.425,0,0,0,.409.331h.706a2.353,2.353,0,0,0-.776,1.75v1.75a2.364,2.364,0,0,0,.563,1.529v1.971A1.147,1.147,0,0,0,2.25,14H3.375A1.147,1.147,0,0,0,4.5,12.833V11.667h9v1.167A1.147,1.147,0,0,0,14.625,14H15.75a1.147,1.147,0,0,0,1.125-1.167V10.862a2.362,2.362,0,0,0,.563-1.529V7.583a2.354,2.354,0,0,0-.776-1.75h.706a.425.425,0,0,0,.409-.331l.211-.875A.434.434,0,0,0,17.578,4.083ZM5.02,3.07A1.8,1.8,0,0,1,6.661,1.75h4.677A1.8,1.8,0,0,1,12.98,3.07l.734,2.18H4.286ZM4.086,9.617A1.267,1.267,0,0,1,2.714,8.308,1.267,1.267,0,0,1,4.086,7,2.585,2.585,0,0,1,6.143,8.963C6.143,9.748,4.909,9.617,4.086,9.617Zm9.829,0c-.823,0-2.057.131-2.057-.654A2.585,2.585,0,0,1,13.914,7a1.267,1.267,0,0,1,1.371,1.308,1.267,1.267,0,0,1-1.371,1.308Z"
                                                    transform="translate(0.503 0.5)"
                                                    fill="#fff"
                                                    stroke="black"
                                                    strokeWidth="1"
                                                />
                                            </svg>
                                        </TableCell>

                                        <TableCell
                                            style={{
                                                minWidth: '25px',
                                                maxWidth: '25px',
                                            }}
                                        ></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.dataProyeccion.map((row, index) => (
                                        <TableRow
                                            id={row.FeeNumber}
                                            key={row.FeeNumber}
                                        >
                                            <TableCell className="borderRadiusProyeccionleft"></TableCell>
                                            <TableCell>
                                                <span className="u-float-left u-h4 u-mr-small">
                                                    {row.FeeNumber}
                                                </span>
                                                {compareDateEqualsHoyProyeccion(
                                                    row.ReferenceDate,
                                                    props.dataProyeccion[
                                                        index + 1
                                                    ]
                                                ) && (
                                                    <div
                                                        className="diaProyeccion u-float-left"
                                                        style={{
                                                            position: 'initial',
                                                            marginTop: '-3px',
                                                        }}
                                                    >
                                                        Hoy
                                                    </div>
                                                )}

                                                {props.opt_CPC_NEXT &&
                                                    compareDateEqualsIPOProyeccion(
                                                        props.rowSelect.IPODate,
                                                        row.ReferenceDate
                                                    ) && (
                                                        <div
                                                            className="color-AA diaProyeccion u-text-white u-float-left"
                                                            style={{
                                                                position:
                                                                    'initial',
                                                                marginTop:
                                                                    '-3px',
                                                            }}
                                                        >
                                                            IPO
                                                        </div>
                                                    )}
                                            </TableCell>
                                            <TableCell>
                                                <span
                                                    style={{
                                                        lineHeight: '26px',
                                                    }}
                                                >
                                                    {new FunctionGeneral().formatFecha(
                                                        row.ReferenceDate.split(
                                                            'T'
                                                        )[0].split('-')
                                                    )}
                                                </span>
                                            </TableCell>
                                            {props.opt_CPC_NEXT && (
                                                <TableCell>
                                                    
                                                        {new FunctionGeneral().formatNum(
                                                            row.PendingCapital  !== null ? row.PendingCapital + " €" : '--'
                                                        )}
                                                </TableCell>
                                            )}
                                            {props.opt_CPC_NEXT && (
                                                <TableCell>
                                                    {new FunctionGeneral().formatNum(
                                                        row.ClientNextPoint !== null ? row.ClientNextPoint : "--" 
                                                    )}
                                                </TableCell>
                                            )}
                                            <TableCell>
                                                {new FunctionGeneral().EsferaColor(
                                                    row.CustomerScoring
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {new FunctionGeneral().EsferaColor(
                                                    row.VehicleScoring
                                                )}
                                            </TableCell>
                                            <TableCell className="borderRadiusProyeccionright"></TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    }
                    <div className="o-layout__item u-1/2">
                        <button
                            className="CancelActividad c-btn--secondary c-btn"
                            onClick={() => props.setModalProyeccion(false)}
                        >
                            CERRAR
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default withRouter(ModalFichaClienteProyeccion);
